// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/near-maximum-weighing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/near-maximum-weighing/near-maximum-weighing.js';

mount([g0]);
